import { DEFAULT_SHAPE_PARAMS } from '../../../pxc_editor_web/src/constants';
var ShapeEntity = {
    shape: null,
    getEmptyShapeProps: function (shapeName) {
        return {
            name: shapeName,
            softEdges: false,
            cornerRadius: DEFAULT_SHAPE_PARAMS.CORNER_RADIUS,
            hasStroke: true,
            strokeWidth: DEFAULT_SHAPE_PARAMS.STROKE_WIDTH,
            isDashed: false,
            isFilled: false,
        };
    },
    setShape: function (shapeName) {
        this.shape = this.getEmptyShapeProps(shapeName);
    },
    resetShape: function () {
        this.shape = null;
    }
};
export default ShapeEntity;
